import React from 'react'

function Bridal() {
  return (
    <div>Bridal</div>
  )
}

export default Bridal